// export default NavigationBar;
import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
// import aziralogo from "../images/aziralogo.png";
import aziralogo from "../images/final2.png";
// import logo from "../images/logo.png";

const NavigationBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`custom-navbar ${scrolled ? "scrolled" : ""}`}
      expanded={expanded}
    >
      <Container>
        <div className="navbar-header">
          <div className="brand-container">
            <img src={aziralogo} alt="Logo" className="brand-logo-img" />
            {/* <span className="brand-name">Aazira Technology</span> */}
          </div>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
            className="toggle-btn"
          >
            <FontAwesomeIcon icon={faBars} />
          </Navbar.Toggle>
        </div>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/"
              onClick={() => setExpanded(false)}
              className={location.pathname === "/" ? "active" : ""}
            >
              Home
            </Nav.Link>
            {/* <Nav.Link
              as={Link}
              to="/safety"
              onClick={() => setExpanded(false)}
              className={location.pathname === "/safety" ? "active" : ""}
            >
              Safety
            </Nav.Link> */}
            <Nav.Link
              as={Link}
              to="/products"
              onClick={() => setExpanded(false)}
              className={location.pathname === "/products" ? "active" : ""}
            >
              Products
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/Services"
              onClick={() => setExpanded(false)}
              className={location.pathname === "/services" ? "active" : ""}
            >
              Services
            </Nav.Link>
            {/* <Nav.Link
              as={Link}
              to="/financial"
              onClick={() => setExpanded(false)}
              className={location.pathname === "/financial" ? "active" : ""}
            >
              Financial Calculation
            </Nav.Link> */}
            <Nav.Link
              as={Link}
              to="/about"
              onClick={() => setExpanded(false)}
              className={location.pathname === "/about" ? "active" : ""}
            >
              About
            </Nav.Link>
          
            <Nav.Link
              as={Link}
              to="/contact"
              onClick={() => setExpanded(false)}
              className={location.pathname === "/contact" ? "active" : ""}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
